<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-04-03 08:37:38
 * @LastEditors: 刘小二
 * @LastEditTime: 2023-04-03 10:03:13
 * @Description: 泵送费用
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/dialog/pumpingCostsEnd.vue
-->
<template>
  <div>
    <div style="display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 0; padding-right: 10px">
      <el-button v-if="!isLook" icon="el-icon-plus" size="small" class="bottom_all" style="margin-left: 0" @click="add()">添加泵送</el-button>
    </div>
    <div>
      <el-table v-loading="tableLoading" :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="tableData.filter(v => v.operate != 0)" tooltip-effect="dark">
        <el-table-column v-for="(item, index) in table" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center" :fixed="item.label == '操作' ? 'right' : false">
          <template slot-scope="scope">
            <span v-if="item.label == '操作'">
              <el-button v-if="scope.row.id && !isLook" class="bottom_one" size="mini" @click="open(scope.row)"> 调价 </el-button>
              <el-button v-if="scope.row.id" class="bottom_one" size="mini" @click="seeInfo(scope.row)"> 查看记录 </el-button>
              <el-button v-if="!isLook" class="bottom_two" size="mini" @click="deleteFun(scope.row, scope.$index)"> 删除 </el-button>
            </span>
            <span v-else-if="item.label == '含税单价（元/m³）'">
              <el-input v-model="scope.row.priceIncludinTax" :disabled="isLook" type="Number" style="width: 200px" @blur="scope.row.priceExcludingTax = ((scope.row.priceIncludinTax * 1) / (1 + (taxRate * 1 == 1 ? 0.03 : 0.13))).toFixed(2)">
              </el-input>
            </span>
            <!-- <span v-else-if="item.label == '不含税单价（元/m³）'">
                            <span>{{scope.row.priceExcludingTax || '0.00'}}</span>
                        </span> -->
            <span v-else-if="item.label == '泵机类型'">
              <el-select v-model="scope.row.costsPumps" :disabled="isLook" value-key="pumpName" multiple placeholder="请选择">
                <el-option v-for="item in pumpList" :key="item.pumpName" :label="item.pumpName" :value="item"></el-option>
              </el-select>
            </span>
            <span v-else>{{ scope.row[item.prop] || "*" }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start; margin-top: 10px">
        <div>补差方式：</div>
        <!-- <el-select v-model="costFromData.type" placeholder="请选择">
                    <el-option v-for="item in dataTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select> -->
      </div>
    </div>
    <div style="margin-top: 10px">
      <span>单次泵送量不足</span>
      <el-input
        v-model="costFromData.square"
        v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
        :disabled="isLook"
        style="width: 160px; margin: 0 20px"
        placeholder="请输入"
        type="Number"
      ></el-input>
      <span>m³，按</span>
      <el-input
        v-model="costFromData.unitPrice"
        v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
        :disabled="isLook"
        style="width: 160px; margin: 0 20px"
        placeholder="请输入"
        type="Number"
      >
      </el-input>
      <span>m³计。</span>
    </div>
  </div>
</template>

<script>
import { queryPumpList, queryPumpCost, savePumpCost } from "@/api/GHnumber/contractPrice.js";
export default {
  props: {
    contractId: {
      type: String,
      default: "",
    },
    taxRate: {
      type: Number,
      default: 0,
    },
    isLook:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      tableParam: {
        page: 1,
        pageSize: 5,
        contractId: "",
      },
      table: [
        { label: "泵机类型", width: "auto", prop: "", status: true },
        { label: "含税单价（元/m³）", width: "auto", prop: "priceIncludinTax", status: true },
        // { label: "不含税单价（元/m³）", width: "120", prop: "priceExcludingTax", status: true },
        { label: "最新调整价格（元/m）", width: "120", prop: "latestAdjustmentsPrice", status: true },
        { label: "操作", width: "auto", prop: "", status: true },
      ],
      tableData: [],
      costFromData: {
        dataType: 1,
        type: 1,
        unitPrice: "",
        square: "",
        contractId: "",
      },
      // 补差类型
      dataTypeOptions: [
        { value: 1, label: "方补" },
        { value: 2, label: "车补" },
      ],
      pumpList: [],
    };
  },
  mounted() {
    queryPumpList({ engId: this.contractId }).then(res => {
      if (res.code == 1001) {
        this.pumpList = [];
        res.data.forEach(item => {
          let data = {
            pumpId: item.id,
            pumpName: item.name,
          };
          this.pumpList.push(data);
        });
        console.log(this.pumpList);
      }
    });
  },
  methods: {
    savePumpCost() {
      this.costFromData.dataType = 1;
      this.costFromData.contractId = this.contractId;
      let data = {
        costs: this.tableData,
        transportation: this.costFromData,
      };
      savePumpCost(data).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功！");
          this.getData();
        }
      });
    },
    getData() {
      queryPumpCost({ engId: this.contractId }).then(res => {
        if (res.code == 1001) {
          res.data.costs.forEach(item => {
            item.operate = 1;
          });
          this.tableData = res.data.costs;
          this.costFromData = res.data.transportation || this.$options.data().costFromData;
        }
      });
    },
    add() {
      let params = {
        costsPumps: [],
        contractId: this.contractId,
        priceExcludingTax: 0,
        priceIncludinTax: 0,
        operate: 2,
        id:'',
      };
      this.tableData.push(params);
      console.log(this.tableData)
    },
    open(val) {
      this.$emit("pumpingCostsSet", "dialog2", val);
    },
    seeInfo(val) {
      this.$emit("pumpingCostsNote", "dialog4", val);
    },
    deleteFun(val, index) {
      if (val.id) {
        val.operate = 0;
      } else {
        this.tableData.splice(index, 1);
      }
    },
    queryResordPageFun() {
      this.tableParam.contractId = this.contractId;
      // queryResordPage(this.tableParam).then(res=>{
      //     if (res.code == 1001 && res.data) {
      //         this.total = res.data.totalRows
      //         this.tableData = res.data.data
      //     }
      // })
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.queryResordPageFun();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
